import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { getLinkDetails } from "../../utils/global";
import { alpha } from "@mui/material/styles";
import { isReviewDeploy } from "../../theme";

export default function ItemTitle({ info, title, dataSource }) {
    const { iconText } = getLinkDetails(dataSource);

    return (
        <Typography variant="h2" sx={{ alignItems: { xs: "top", md: "center" } }}>
            <Box
                sx={(theme) => ({
                    height: "10px",
                    color: "primary.fontColor",
                    borderRadius: "50px",
                    display: { xs: "none", md: "flex" },
                    fontSize: { xs: "7.6px", md: "8px" },
                    fontWeight: "bold",
                    minWidth: '50px',
                    backgroundColor:
                        theme.palette.mode === "dark" ? "secondary.dark" : "secondary.main",
                    alignItems: "center",
                    justifyContent: "center",
                    py: { xs: "10px", md: "11px" },
                    px: { xs: "5px", md: "6px" },
                    textAlign: "center",
                    letterSpacing: iconText === "AQUA STAT" ? "-0.5pt" : null,
                    mr: { xs: 1, md: 1.5 },
                    lineHeight: 1,
                    border: !info.flag_sdg
                        ? (theme) =>
                            `2px solid ${alpha(theme.palette.primary.fontColor, 0.7)}`
                        : null,
                    position: "relative",
                    "&::before": info.flag_sdg
                        ? {
                            content: '""',
                            position: "absolute",
                            top: "-2px",
                            left: "-2px",
                            right: "-2px",
                            bottom: "-2px",
                            background:
                                "linear-gradient(90deg, #eb1c2e, #d19e29, #2c9946, #c32033, #ef402b, #01acd8, #fcb714, #8f1838, #f26e24, #df1a83, #f99c25, #c98a2b, #47773b, #017dbb, #3eb049, #005689, #1f3668)",
                            borderRadius: "50px",
                            padding: "2px",
                            WebkitMask:
                                "linear-gradient(white 0 0) content-box, linear-gradient(white 0 0)",
                            WebkitMaskComposite: "destination-out",
                            maskComposite: "exclude",
                            zIndex: 0,
                        }
                        : null,
                })}
            >
                {iconText}
            </Box>
            {isReviewDeploy && info?.uid !== undefined && (
                <Box
                    component="span"
                    sx={(theme) => ({
                        fontFamily: "monospace",
                        fontSize: "11px",
                        fontWeight: "normal",
                        color: "primary.main",
                        border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`,
                        borderRadius: "4px",
                        px: "5px",
                        mr: 1,
                        lineHeight: 1.6,
                    })}
                >
                    uid:{info.uid}
                </Box>
            )}
            {title}
        </Typography>
    );
}
